import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon, SmartphoneIcon, WatchIcon, HeadphonesIcon, BatteryChargingIcon, ZapIcon, Gamepad2Icon, MonitorIcon, TagIcon, SparklesIcon } from 'lucide-react';
import { categories } from '../../data/categories';
const iconMap: Record<string, React.ReactNode> = {
  Smartphone: <SmartphoneIcon className="w-5 h-5" data-id="element-419" />,
  Watch: <WatchIcon className="w-5 h-5" data-id="element-420" />,
  Headphones: <HeadphonesIcon className="w-5 h-5" data-id="element-421" />,
  Battery: <BatteryChargingIcon className="w-5 h-5" data-id="element-422" />,
  Zap: <ZapIcon className="w-5 h-5" data-id="element-423" />,
  Gamepad2: <Gamepad2Icon className="w-5 h-5" data-id="element-424" />,
  Monitor: <MonitorIcon className="w-5 h-5" data-id="element-425" />
};
export function Navigation() {
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  return <nav className="bg-primary-600 text-white sticky top-[72px] z-30" data-id="element-426">
      <div className="max-w-7xl mx-auto px-4" data-id="element-427">
        <div className="flex items-center justify-between h-12" data-id="element-428">
          {/* Categories dropdown */}
          <div className="relative" data-id="element-429">
            <button className="flex items-center gap-2 px-4 py-2 bg-primary-700 rounded-lg hover:bg-primary-800 transition-colors" onClick={() => setIsCategoriesOpen(!isCategoriesOpen)} onMouseEnter={() => setIsCategoriesOpen(true)} aria-expanded={isCategoriesOpen} aria-haspopup="true" data-id="element-430">
              <span className="font-medium" data-id="element-431">Categories</span>
              <ChevronDownIcon className={`w-4 h-4 transition-transform ${isCategoriesOpen ? 'rotate-180' : ''}`} data-id="element-432" />
            </button>

            {isCategoriesOpen && <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-xl shadow-dropdown py-2 z-50" onMouseLeave={() => setIsCategoriesOpen(false)} data-id="element-433">
                {categories.map(category => <Link key={category.id} to={`/products?category=${category.slug}`} className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors" onClick={() => setIsCategoriesOpen(false)} data-id="element-434">
                    <span className="text-primary-600" data-id="element-435">
                      {iconMap[category.icon] || <TagIcon className="w-5 h-5" data-id="element-436" />}
                    </span>
                    <span className="font-medium" data-id="element-437">{category.name}</span>
                    <span className="ml-auto text-sm text-gray-400" data-id="element-438">
                      {category.productCount}
                    </span>
                  </Link>)}
              </div>}
          </div>

          {/* Main navigation links */}
          <div className="hidden md:flex items-center gap-1" data-id="element-439">
            <Link to="/products?featured=true" className="flex items-center gap-1.5 px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors" data-id="element-440">
              <SparklesIcon className="w-4 h-4" data-id="element-441" />
              <span className="font-medium" data-id="element-442">Spotlight</span>
            </Link>
            <Link to="/products?deals=true" className="flex items-center gap-1.5 px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors" data-id="element-443">
              <TagIcon className="w-4 h-4" data-id="element-444" />
              <span className="font-medium" data-id="element-445">Deals</span>
            </Link>
            <Link to="/products?new=true" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-446">
              New Arrivals
            </Link>
            <Link to="/products?bestseller=true" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-447">
              Best Sellers
            </Link>
          </div>

          {/* Right side links */}
          <div className="hidden md:flex items-center gap-1" data-id="element-448">
            <Link to="/about" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-449">
              About Us
            </Link>
            <Link to="/contact" className="px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors font-medium" data-id="element-450">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </nav>;
}